import {
  Axe, Scissors, Sprout, Grip, CloudLightning, Siren, Trees,
  Trash2, Leaf, Search, TriangleAlert, Home, Building2, TreePine
} from "lucide-react";

// Maps the icon string stored in the CMS to a lucide component
export const ICON_MAP = {
  Axe, Scissors, Sprout, Grip, CloudLightning, Siren, Trees,
  Trash2, Leaf, Search, TriangleAlert, Home, Building2, TreePine,
};

export const IMAGES = {
  logo: "/logo-top-of-the-line.png",
  hero: "https://customer-assets-7cd3h4nn.emergentagent.net/job_arborist-services-3/artifacts/ubt7y6bu_PHOTO-2026-07-22-21-06-36.jpg",
  aboutClimb: "https://customer-assets-7cd3h4nn.emergentagent.net/job_arborist-services-3/artifacts/79fjbe8z_PHOTO-2026-07-22-20-56-10.jpg",
};

export const DEFAULT_COMPANY = {
  name: "Top of the Line Tree Services LLC",
  short: "Top of the Line",
  phone: "(256) 375-8064",
  phoneRaw: "+12563758064",
  email: "",
  tagline: "Professional Tree Services You Can Trust",
  sub: "More than 20 years of experience serving Huntsville, North Alabama and Tennessee.",
  years: "20+",
  facebook: "#",
  google: "#",
  hours: "Mon\u2013Sat: 7:00 AM \u2013 7:00 PM \u00b7 Sunday: Emergency only",
  licensed_insured: true,
  emergency_247: true,
  logo: IMAGES.logo,
  hero_image: IMAGES.hero,
  about_image: IMAGES.aboutClimb,
  about_text: "Top of the Line Tree Services LLC is a family-run company with more than 20 years of experience helping homeowners, businesses and commercial properties across Huntsville, North Alabama and Tennessee.",
  areas: ["Huntsville", "Madison", "Decatur", "Athens", "Harvest", "Meridianville", "Hazel Green", "North Alabama", "Nearby Tennessee communities"],
  promo: "",
};

export const MANIFESTO = [
  { n: "01", h: "20+ years of experience", p: "Two decades of hands-on tree work across North Alabama and Tennessee \u2014 there is no job we haven't seen." },
  { n: "02", h: "Safety above everything", p: "Trained crews, proper rigging and the right equipment protect your property and everyone on site." },
  { n: "03", h: "Personalized attention", p: "We listen first, walk your property, and recommend only the work you actually need." },
  { n: "04", h: "We leave it spotless", p: "Every branch and piece of debris is hauled away. We clean up like we were never there." },
];

export const FAQS = [
  { q: "Do you offer free estimates?", a: "Yes. We provide free, no-obligation estimates for all of our tree services." },
  { q: "Do you provide emergency tree services?", a: "Yes, we offer 24/7 emergency tree services for dangerous and storm-damaged trees." },
  { q: "Are you licensed and insured?", a: "Yes. Top of the Line Tree Services LLC is fully licensed and insured for your protection." },
  { q: "How quickly can you visit my property?", a: "In most cases we can schedule a visit within a few days, and much faster for emergencies." },
  { q: "Do you remove all branches and debris?", a: "Absolutely. We haul away all branches and debris and clean the site after every job." },
  { q: "Can I send pictures before scheduling an estimate?", a: "Yes \u2014 you can upload photos or videos of the tree or area directly in our request form." },
  { q: "Do you work with residential and commercial properties?", a: "Yes, we serve both homeowners and commercial/business properties." },
  { q: "What areas do you serve?", a: "Huntsville, Madison, Decatur, Athens, Harvest, Meridianville, Hazel Green, North Alabama and nearby Tennessee communities." },
  { q: "What happens if a tree falls during a storm?", a: "Call us right away. Our emergency crew responds quickly to safely remove fallen or hazardous trees." },
  { q: "Does choosing a date guarantee my appointment?", a: "No. A selected date is a request only and is not confirmed until our team approves and contacts you." },
];

export const TIME_WINDOWS = ["Morning (8AM\u201312PM)", "Afternoon (12PM\u20134PM)", "Evening (4PM\u20137PM)", "Flexible"];
